import styled from 'styled-components';

import { IconOpenNewTab } from '@components/icons/open-new-tab';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export const JobBoardLink = ({ link }) => {
  return (
    <Anchor href={`https://${link}`} target="_blank" rel="noopener noreferrer">
      <IconOpenNewTab />
      {link}
    </Anchor>
  );
};

const Anchor = styled.a({
  display: 'inline-flex',
  alignItems: 'center',
  gap: pxToRem(12),
  color: theme.color.textPrimary,
  '--icon-color': theme.color.purple50,
  textDecoration: 'none',
  transition: 'color 150ms ease',
  ':hover': {
    color: theme.color.blue100,
    '--icon-color': theme.color.blue100,
    textDecoration: 'underline',
  },
});
